export default "__VITE_ASSET__5dcb25cb__"